import React from "react";
import { Route } from "react-router-dom";
import type { Navigation, NavigationPageItem } from "types/navigation";

export const mapPagesToReactRouter = (
  pages: Navigation,
  RouteComponent: React.ComponentType<any>
) => {
  return pages.map((page) => {
    if (page.kind === "header" || page.kind === "divider") {
      return null;
    }

    const typedPage = page as NavigationPageItem;

    // External links are handled in the drawer only.
    if (typedPage.href && !typedPage.component) {
      return null;
    }

    if ("children" in typedPage && typedPage.children) {
      return typedPage.children.map((child) => {
        if (child.kind === "header" || child.kind === "divider") {
          return null;
        }

        const typedChild = child as NavigationPageItem;

        if (typedChild.component) {
          const basePath = `${typedPage.segment}/${typedChild.segment}`;
          return (
            <React.Fragment key={basePath}>
              <Route
                path={basePath}
                element={
                  <RouteComponent>{typedChild.component}</RouteComponent>
                }
              />
              {(typedChild.slugBabyRoutes?.length
                ? typedChild.slugBabyRoutes
                : typedChild.slugBabyPattern && typedChild.slugBabyComponent
                  ? [
                      {
                        pattern: typedChild.slugBabyPattern,
                        component: typedChild.slugBabyComponent,
                      },
                    ]
                  : []
              ).map((slugRoute) => (
                <React.Fragment key={`${basePath}/${slugRoute.pattern}`}>
                  <Route
                    path={`${basePath}/${slugRoute.pattern}`}
                    element={
                      <RouteComponent>{slugRoute.component}</RouteComponent>
                    }
                  />
                  {typedChild.slugGrandBabyPattern &&
                    typedChild.slugGrandBabyComponent &&
                    slugRoute.pattern === typedChild.slugBabyPattern && (
                      <Route
                        path={`${basePath}/${slugRoute.pattern}/${typedChild.slugGrandBabyPattern}`}
                        element={
                          <RouteComponent>
                            {typedChild.slugGrandBabyComponent}
                          </RouteComponent>
                        }
                      />
                    )}
                </React.Fragment>
              ))}
            </React.Fragment>
          );
        }
        return null;
      });
    }

    if (typedPage.component) {
      return (
        <React.Fragment key={typedPage.segment}>
          <Route
            path={`/${typedPage.segment}`}
            element={<RouteComponent>{typedPage.component}</RouteComponent>}
          />
          {(typedPage.slugBabyRoutes?.length
            ? typedPage.slugBabyRoutes
            : typedPage.slugBabyPattern && typedPage.slugBabyComponent
              ? [{ pattern: typedPage.slugBabyPattern, component: typedPage.slugBabyComponent }]
              : []
          ).map((slugRoute) => (
            <React.Fragment key={`${typedPage.segment}/${slugRoute.pattern}`}>
              <Route
                path={`/${typedPage.segment}/${slugRoute.pattern}`}
                element={
                  <RouteComponent>{slugRoute.component}</RouteComponent>
                }
              />
              {typedPage.slugGrandBabyPattern &&
                typedPage.slugGrandBabyComponent &&
                slugRoute.pattern === typedPage.slugBabyPattern && (
                  <Route
                    path={`/${typedPage.segment}/${slugRoute.pattern}/${typedPage.slugGrandBabyPattern}`}
                    element={
                      <RouteComponent>
                        {typedPage.slugGrandBabyComponent}
                      </RouteComponent>
                    }
                  />
                )}
            </React.Fragment>
          ))}
        </React.Fragment>
      );
    }

    return null;
  });
};
